import type { ProductListNode } from "interfaces/node/node.types";

export interface CategoryItem {
  key: string;
  name: string;
  class: string[];
}

export interface SeriesItem {
  key: string;
  name: string;
  class: string[];
  serieId: number;
  parentName?: string | null;
  parentCategories: string[];
  isSerie: true;
}

export const getCategoryOrSeriesMap = (
  allProducts: ProductListNode[],
): [Map<string, CategoryItem>, Map<string | number, SeriesItem>] => {
  const categories = new Map<string, CategoryItem>();
  const series = new Map<string | number, SeriesItem>();

  const extract = (
    nodes: ProductListNode[] | undefined,
    parents: string[] = [],
  ): void => {
    nodes?.forEach((node) => {
      if ("nodes" in node && node.nodes && node.nodes.length > 0) {
        categories.set(node.key, {
          key: node.key,
          name: node.name,
          class: node.keyList,
        });
        extract(node.nodes, [...parents, node.name]);
      } else if ("serieId" in node && node.serieId) {
        series.set(node.serieId, {
          key: node.key,
          name: node.name,
          class: node.keyList,
          serieId: node.serieId,
          parentName: node.parentId,
          parentCategories: parents,
          isSerie: true,
        });
      }
    });
  };

  extract(allProducts, []);
  return [categories, series];
};

interface FindKeylistBySeriesIdParams {
  seriesMap: Map<string | number, SeriesItem>;
  productSeriesId: string | number;
}

export const findKeylistBySeriesId = ({
  seriesMap,
  productSeriesId,
}: FindKeylistBySeriesIdParams): string[] => {
  const id = Number(productSeriesId);

  for (const [, item] of seriesMap) {
    if (item?.serieId === id) {
      return item.class;
    }
  }

  return [];
};

export interface FindSeriesKeylistByKeyParams {
  seriesMap: Map<string | number, SeriesItem>;
  targetKey: string;
}

export const findSeriesKeylistByKey = ({
  seriesMap,
  targetKey,
}: FindSeriesKeylistByKeyParams): string[] => {
  for (const [, item] of seriesMap) {
    if (item?.key === targetKey) {
      return item.class;
    }
  }

  return [];
};
